@if (canToggle()) {
  <button
    type="button"
    class="driver_active_toggle"
    [class.is_active]="active()"
    [class.is_saving]="saving()"
    role="switch"
    [attr.aria-checked]="active()"
    [attr.aria-label]="(active() ? 'active' : 'inactive') | translate"
    [attr.aria-busy]="saving()"
    (click)="toggle()">
    @if (active()) {
      <img
        ngSrc="assets/images/driver-toggle-on.svg"
        width="72"
        height="72"
        alt=""
        draggable="false"
        priority />
    } @else {
      <img
        ngSrc="assets/images/driver-toggle-off.svg"
        width="72"
        height="72"
        alt=""
        draggable="false"
        priority />
    }
  </button>
}
